export const styles = {
  textWidget: {
    paddingY: 2,
    paddingX: 3,
    position: 'relative',
  },

  text: {
    whiteSpace: 'pre-line',
  },
};
